import request from '@/utils/request'

export function getBookingList(params) {
  return request({
    url: '/api/admin/Booking',
    method: 'get',
    params
  })
}

export function getBookingDetail(id) {
  return request({
    url: `/api/admin/Booking/${id}`,
    method: 'get'
  })
}

export function createBooking(data) {
  return request({
    url: '/api/admin/Booking',
    method: 'post',
    data
  })
}

export function updateBooking(id, data) {
  return request({
    url: `/api/admin/Booking/${id}`,
    method: 'put',
    data
  })
}

export function deleteBooking(id) {
  return request({
    url: `/api/admin/Booking/${id}`,
    method: 'delete'
  })
}

// Cancel specific hour from booking (updated endpoint)
export function cancelBookingHour(bookingId, hour, bookingDate) {
  return request({
    url: `/api/admin/Booking/${bookingId}/date/${bookingDate}/hour/${hour}`,
    method: 'delete'
  })
}

// Delete all hours for a specific day
export function deleteBookingDay(bookingId) {
  return request({
    url: `/api/admin/Booking/${bookingId}/day`,
    method: 'delete'
  })
}

export function cancelBooking(id, data) {
  return request({
    url: `/api/admin/Booking/${id}/cancel`,
    method: 'post',
    data
  })
}

export function cancelAllBookingHours(id, data) {
  return request({
    url: `/api/admin/Booking/${id}/cancel-all`,
    method: 'post',
    data
  })
}

export function confirmBooking(id) {
  return request({
    url: `/api/admin/Booking/${id}/confirm`,
    method: 'post'
  })
}

// Get bookings for export
export function getBookingsForExport(params) {
  return request({
    url: '/api/admin/Booking',
    method: 'get',
    params
  })
}

// Get booking policies
export function getBookingPolicies() {
  return request({
    url: '/api/common/booking-policies',
    method: 'get'
  })
}
